import { useSelector } from 'react-redux'

import { selectNavigation } from 'redux/selectors/NavigationMenu'

export const useNavigation = () => {
  return useSelector(selectNavigation)
}
